/**
 * Development environment configuration for the Symbox homepage application.
 * Contains API endpoints, authentication keys, and environment-specific settings.
 *
 * @remarks This file can be replaced during build by using the `fileReplacements` array.
 * `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
 * The list of file replacements can be found in `angular.json`.
 */

/**
 * Development environment configuration object.
 *
 * @remarks Contains all environment-specific configuration values including
 * production flags, API endpoints, and authentication credentials for development.
 */
export const environment = {
  /** Flag indicating if the application is running in production mode */
  production: false,

  /** API configuration for backend communication */
  api: {
    /** API application name for authentication */
    name: 'SymboxHomepage',
    /** API key for authentication with the backend service */
    key: 'hh22?-q-3*R2px+2!epaD_2',
    /** Base URL for the external API endpoint */
    url: 'https://extapi.gw.inexio.net/extApi.php',
  },
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
